import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "setup"
    }}>{`Setup`}</h3>
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/integrate/setup/developer-credentials/"
      }}>{`How to get your developer credentials`}</a></p>
    <p>{`Before you get started, you'll need a Client ID and Secret. We'll show you how to get them on the Adobe Developer Console.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/integrate/setup/oauth/"
      }}>{`How to get access tokens with OAuth`}</a></p>
    <p>{`See where to learn more about Adobe OAuth 2.0 and try our OAuth 2.0 Playground for a quicker start.`}</p>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      